const getHeaderTitle = (pathname) => {
  if (pathname === "/") {
    return "Home";
  } else if (pathname.startsWith("/about")) {
    return "About Page";
  } else if (pathname.includes("/product/")) {
    return "Product Detail";
  } else if (/\/blog\/[a-zA-Z0-9-]+/.test(pathname)) {
    return "Blog Post";
  } else if (pathname === "/contact") {
    return "Contact Page";
  } else if (pathname.startsWith("/events")) {
    return "Events";
  } else if (pathname.startsWith("/venue")) {
    return "Venues";
  } else if (pathname === "/settings") {
    return "Settings";
  }
    else if (pathname === "/create-venue") {
    return "Create Venue";
  } else {
    return "Page Not Found";
  }
};
export default getHeaderTitle;
